import { inject, injectable } from "inversify";
import { TokenProvider } from "./services";

@injectable()
export default class ApiConfiguration {
  constructor(
    @inject(TokenProvider) private authModule: TokenProvider,
    @inject("RestServiceBasePath") readonly basePath: string
  ) {}

  get accessToken(): string {
    const token = this.authModule.getToken();
    if (token == null) {
      throw Error("Keycloak token missing");
    }
    return token;
  }
}
